import { Rndm } from './Rndm.js';
import { Arry } from './Arry.js';
import { scrn_type } from './Scrn.js';

export interface css_input {
    res: number;
    parent: HTMLElement;
    [key: string]: any
}

export interface css_manager_type {
    list: HTMLElement[];
    get: (id: string) => HTMLElement | null;
    kill: (id: string) => void;
    make_layer: (options: css_input) => HTMLElement;
    make_rect: (options?: any) => HTMLElement;
    make_canvas: (options?: any) => HTMLCanvasElement;
    make_canvas_fullscreen: (options?: any) => HTMLCanvasElement;
    makeTable: (options?: any) => HTMLTableElement;
    make_input: (options?: any) => HTMLInputElement;
    make_dropdown: (options?: any) => HTMLSelectElement;
}

export function css_position(dom: HTMLElement, x: number, y: number, res: number, rotate: number = 0): void {
    dom.style.transform = "translateX(" + (x * res) + "px) translateY(" + (y * res) + "px) rotate(" + rotate + "deg)";
}

export function css_transform_px(io: HTMLElement, t: any, res = 1) {

    const align = t.align || "center";
    const valign = t.valign || "center";
    const px = (v: number) => (v * res) + "px";

    if (t.width !== undefined) io.style.width = px(t.width * 2);
    if (t.height !== undefined) io.style.height = px(t.height * 2);

    const tx = align === "center" ? "-50%" : "0";
    const ty = valign === "center" ? "-50%" : "0";
    if (tx !== "0" || ty !== "0") io.style.translate = tx + " " + ty;

    if (t.x !== undefined) {
        if (align === "left") { io.style.left = px(t.x); io.style.right = "auto"; }
        else if (align === "right") { io.style.right = px(t.x); io.style.left = "auto"; }
        else { io.style.left = t.x !== 0 ? "calc(50% + " + px(t.x) + ")" : "50%"; io.style.right = "auto"; }
    }
    if (t.y !== undefined) {
        if (valign === "top") { io.style.top = px(t.y); io.style.bottom = "auto"; }
        else if (valign === "bottom" || valign === "end") { io.style.bottom = px(t.y); io.style.top = "auto"; }
        else { io.style.top = t.y !== 0 ? "calc(50% + " + px(t.y) + ")" : "50%"; io.style.bottom = "auto"; }
    }
}

export function get_global_position(element: HTMLElement, Scrn: scrn_type) {
    const rect = element.getBoundingClientRect();
    const x = rect.left + rect.width * 0.5;
    const y = rect.top + rect.height * 0.5;
    return Scrn.to_twrk({ x, y });
}

export function css_manager(): css_manager_type {

    const self = {
        list: [] as HTMLElement[],
        get: function (id: string): HTMLElement | null {
            const result = Arry.get.id(this.list, id);
            return result as HTMLElement | null;
        },
        kill: function (id: string): void {
            const to_delete = Arry.get.id(this.list, id);
            if (to_delete) {
                to_delete.remove();
                Arry.remove.id(this.list, id);
            }
        },
        make_layer: function (options: css_input): HTMLElement {

            const { parent, res, id = Rndm.id(), x = 0, y = 0, r = 0, width = 0, height = 0, zindex = false, opacity = false } = options;

            if (!parent) {
                throw new Error("No parent element available.");
            }
            const e = document.createElement("layer");
            e.id = id;
            if (zindex) e.style.zIndex = String(zindex);
            e.style.width = (width * res) + "px";
            e.style.height = (height * res) + "px";
            css_position(e, x, y, res, r !== 0 ? r : undefined);
            if (opacity !== undefined) e.style.opacity = String(opacity);
            parent.appendChild(e);
            this.list.push(e);
            return e;
        },
        make_rect: function (options: any = {}): HTMLElement {

            const { parent, id = Rndm.id(), res, x = 0, y = 0, r = 0, padding, width, height, color = "transparent", opacity, radius, stroke, stroke_color, text, line_height, line_offset, text_kerning, text_size = 0.025, text_color = "#333333", text_font = "etter-sans-book", box_shadow, align = "center", valign = "center", video, loop, autoplay, image, cursor = "auto", pointer = "auto", on_down, on_up, over, out, link, blur, shape = "rect", passive, display = "flex", classes, padding_left, padding_right, padding_top, padding_bottom, background_blur, position } = options;

            if (!parent) throw new Error("No parent element available.");

            const e = document.createElement("rect");

            e.id = id;

            if (r !== 0) e.style.transform = "rotate(" + r + "deg)";

            // position, size, alignment
            css_transform_px(e, { x, y, align, valign, width, height }, res);

            if (position) e.style.position = position;


            if (valign === "top" && line_offset !== 0) e.style.marginTop = (line_offset * res) + "px";

            if (padding) {
                e.style.padding = (padding * res) + "px";
            } else {
                if (padding_left) e.style.paddingLeft = (padding_left * res) + "px";
                if (padding_top) e.style.paddingTop = (padding_top * res) + "px";
                if (padding_right) e.style.paddingRight = (padding_right * res) + "px";
                if (padding_bottom) e.style.paddingBottom = (padding_bottom * res) + "px";
            }

            e.style.background = color;

            if (opacity !== undefined) e.style.opacity = String(opacity);
            e.style.cursor = cursor;
            e.style.pointerEvents = pointer;
            e.style.borderRadius = (radius * res) + "px";

            if (stroke > 0) {
                e.style.border = "solid";
                e.style.borderWidth = (stroke * res) + "px";
                e.style.borderColor = stroke_color ?? color;
            } else {
                e.style.border = "none";
            }

            if (shape == "circle") {
                e.style.borderRadius = "50%";
            } else if (shape == "triangle") {
                e.style.width = "0px";
                e.style.minHeight = "0px";
                e.style.background = "transparent";
                e.style.border = "none";
                e.style.borderLeft = (height * res) + "px solid transparent";
                e.style.borderRight = (height * res) + "px solid transparent";
                e.style.borderBottom = (width * 2 * res) + "px solid " + color;
            }

            if (box_shadow) e.style.boxShadow = (box_shadow.x || 0) * res + "px " + (box_shadow.y || 0) * res + "px " + (box_shadow.blur || 0.1) * res + "px " + (box_shadow.wide || 0) * res + "px " + box_shadow.color || "rgb(0 0 0 / 20%)";
            if (blur) e.style.filter = "blur(" + (blur * res) + "px)";
            if (background_blur) e.style.backdropFilter = "blur(" + (background_blur * res) + "px)";

            // Content alignment (for children of this element)
            e.style.display = display;
            e.style.alignItems = valign;
            e.style.justifyContent = align;

            if (text !== undefined) {
                e.style.color = text_color;
                e.style.fontSize = (text_size * res) + "px";
                e.style.fontFamily = text_font;
                e.style.textAlign = align;
                e.style.letterSpacing = (text_kerning * res) + "px";
                if (line_height) e.style.lineHeight = String(line_height);
                e.innerHTML = text;
                if (link) e.innerHTML = "<a href='" + link + "'>" + text + "</a>";
            }

            if (video) {
                const v = document.createElement("video");
                v.src = video;
                if (loop) v.setAttribute("loop", "");
                if (autoplay) {
                    v.setAttribute("muted", "");
                    v.setAttribute("playsinline", "");
                    v.setAttribute("autoplay", "");
                }
                v.style.width = "100%";
                v.style.height = "100%";
                v.style.objectFit = "cover";
                e.appendChild(v);
                (e as any).video = true;
            }

            if (image) {
                let i = document.createElement("img");
                i.src = image;
                i.style.width = "100%";
                i.style.height = "100%";
                i.style.objectFit = "cover";
                e.appendChild(i);
                (e as any).image = true;
            }

            // Event handlers
            if (passive) {
                e.style.pointerEvents = "none";
            } else {
                if (over) e.addEventListener("pointerover", (event: PointerEvent) => {
                    over(event);
                });
                if (out) e.addEventListener("pointerout", (event: PointerEvent) => {
                    out(event);
                });
                if (on_down) {
                    e.addEventListener("pointerdown", (event: PointerEvent) => {
                        on_down(event);
                        event.preventDefault();
                    }, { passive: false });
                }
                if (on_up) {
                    e.addEventListener("pointerup", (event: PointerEvent) => {
                        on_up(event);
                        event.preventDefault();
                    }, { passive: false });
                }
            }

            if (classes) e.classList.add(...classes);
            parent.appendChild(e);

            // Adjust centering for auto-sized elements
            if (!width && align === "center") {
                const actualWidth = e.offsetWidth;
                e.style.marginLeft = (actualWidth * -0.5) + "px";
                // Left is already set to 50% or calc(50% + x)
            }

            if (!height && valign === "center") {
                const actualHeight = e.offsetHeight;
                e.style.marginTop = (actualHeight * -0.5) + "px";// Top is already set to 50% or calc(50% + y)
            }

            if (!width && align === "right") {
                const actualWidth = e.offsetWidth;
                e.style.right = "calc(" + (x * res) + "px + " + actualWidth + "px)";
            }

            if (!height && (valign === "bottom" || valign === "end")) {
                const actualHeight = e.offsetHeight;
                e.style.bottom = "calc(" + (y * res) + "px + " + actualHeight + "px)";
            }

            this.list.push(e);
            return e;
        },

        make_canvas_fullscreen: function (options: any = {}): HTMLCanvasElement {

            const { parent, id = Rndm.id(), color = "transparent", opacity, centerX = window.innerWidth / 2, centerY = window.innerHeight / 2 } = options;

            if (!parent) throw new Error("No parent element available.");

            const c = document.createElement("canvas");
            c.id = id;
            c.width = window.innerWidth;
            c.height = window.innerHeight;
            c.style.transform = "translate(-" + centerX + "px, -" + centerY + "px)";
            c.style.transform = "translate(-" + centerX + "px, -" + centerY + "px)";
            c.style.backgroundColor = color;
            if (opacity !== undefined) c.style.opacity = String(opacity);

            c.addEventListener('webglcontextlost', (e) => {
                e.preventDefault();
                console.log("Context lost, releasing resources");
            });

            parent.appendChild(c);
            this.list.push(c);
            return c;
        },

        make_canvas: function (options: any = {}): HTMLCanvasElement {

            const { parent, id = Rndm.id(), res, x = 0, y = 0, width, height, color = "transparent", opacity, align = "center", valign = "center", classes } = options;

            if (!parent) throw new Error("No parent element available.");


            const c = document.createElement("canvas");
            c.id = id;
            css_transform_px(c, { x, y, align, valign, width, height }, res);


            c.style.backgroundColor = color;
            if (opacity !== undefined) c.style.opacity = String(opacity);
            if (classes) c.classList.add(...classes);

            c.addEventListener('webglcontextlost', (e) => {
                e.preventDefault();
                console.log("Context lost, releasing resources");
            });

            parent.appendChild(c);
            this.list.push(c);
            return c;
        },

        makeTable: function (options: any = {}): HTMLTableElement {
            const {
                parent,
                id,
                header = ["A", "B", "C"],
                ia = [[2, 3, 5], [3, 3, 3]]
            } = options;
            const defaultId = id ?? Rndm.id();

            if (!parent) {
                throw new Error("No parent element available.");
            }

            const table = document.createElement("table");
            table.id = defaultId;

            if (header) {
                const thead = document.createElement("thead");;
                const trhead = document.createElement("tr");;
                for (let j = 0; j < header.length; j++) {
                    const cell = document.createElement("th");
                    cell.innerHTML = header[j];
                    trhead.appendChild(cell);
                }
                thead.appendChild(trhead);
                table.appendChild(thead);
            }

            const tbody = document.createElement("tbody");;
            for (let i = 0; i < ia.length; i++) {
                const row = document.createElement("tr");
                for (let j = 0; j < ia[i].length; j++) {
                    if (j == 0) {
                        const cell = document.createElement("th");
                        cell.innerHTML = String(ia[i][j]);
                        row.appendChild(cell);
                    } else {
                        const cell = document.createElement("td");
                        cell.innerHTML = String(ia[i][j]);
                        row.appendChild(cell);
                    }
                }
                tbody.appendChild(row);
            }
            table.appendChild(tbody);

            parent.appendChild(table);
            this.list.push(table);
            return table;
        },

        make_input: function (options: any = {}): HTMLInputElement {

            const { parent, on_down, on_input, position, type = "range", id = Rndm.id(), width, height, x = 0, y = 0, align = "center", valign = "center", stroke, stroke_color, radius, padding, color = "transparent", name, value, min, max, step, res = 0.01, ticks = [], on_change, text_color, text_font, text_size, padding_left, padding_right, padding_top, padding_bottom, background_blur } = options;

            if (!parent) throw new Error("No parent element available.");

            const e = document.createElement("input");

            e.id = id;
            e.type = type;

            if (name) e.name = name;
            if (min !== undefined) e.min = String(min);
            if (max !== undefined) e.max = String(max);
            if (step !== undefined) e.step = step;
            if (value !== undefined) e.value = value;

            css_transform_px(e, { x, y, align, valign, width, height }, res);
            if (position) e.style.position = position;

            if (padding) {
                e.style.padding = (padding * res) + "px";
            } else {
                if (padding_left) e.style.paddingLeft = (padding_left * res) + "px";
                if (padding_top) e.style.paddingTop = (padding_top * res) + "px";
                if (padding_right) e.style.paddingRight = (padding_right * res) + "px";
                if (padding_bottom) e.style.paddingBottom = (padding_bottom * res) + "px";
            }

            e.style.background = color;
            if (background_blur) e.style.backdropFilter = "blur(" + (background_blur * res) + "px)";

            if (stroke > 0) {
                e.style.border = "solid";
                e.style.borderWidth = (stroke * res) + "px";
                e.style.borderColor = stroke_color ?? color;
            } else {
                e.style.border = "none";
            }

            e.style.borderRadius = (radius * res) + "px";

            if (type == "range" && ticks.length > 0) {
                const d = document.createElement("datalist");
                d.id = Rndm.id();
                for (const t of ticks) {
                    const o = document.createElement("option");
                    o.value = String(t);
                    d.appendChild(o)
                }
                e.setAttribute("list", d.id);
                e.appendChild(d);
            }

            if (type == "text" && value) {
                e.value = String(value);
            }

            if (text_color) e.style.color = text_color;
            if (text_size) e.style.fontSize = (text_size * res) + "px";
            if (text_font) e.style.fontFamily = text_font;

            if (on_change) e.addEventListener("change", (event: Event) => { on_change(event); });
            if (on_input) e.addEventListener("input", (event: Event) => { on_input(event); });
            if (on_down) e.addEventListener("pointerdown", (event: Event) => { on_down(event); });

            parent.appendChild(e);
            this.list.push(e);
            return e;
        },

        make_dropdown: function (io: any = {}): HTMLSelectElement {

            const { parent, options, position, passive, on_down, id = Rndm.id(), width, height, x = 0, y = 0, align = "center", valign = "center", stroke, stroke_color, radius, padding, color = "transparent", name, res = 0.01, on_change, text_size, text_color, text_font, background_blur } = io;

            if (!parent) throw new Error("No parent element available.");

            const e = document.createElement("select");

            e.id = id;

            if (name) e.name = name;

            for (const t of options) {
                const o = document.createElement('option');
                if (typeof t === 'string' || typeof t === 'number') { // Simple string/number option
                    o.value = String(t);
                    o.textContent = String(t);
                } else if (typeof t === 'object' && t !== null) {
                    o.value = t.value !== undefined ? String(t.value) : ''; // Object option with value and text
                    o.textContent = t.text !== undefined ? t.text : (t.value !== undefined ? String(t.value) : '');
                    if (t.selected) o.selected = true;
                    if (t.disabled) o.disabled = true;
                }
                e.appendChild(o);
            }

            css_transform_px(e, { x, y, align, valign, width, height }, res);
            if (position) e.style.position = position;

            if (padding) e.style.padding = (padding * res) + "px";

            e.style.background = color;
            if (background_blur) e.style.backdropFilter = "blur(" + (background_blur * res) + "px)";

            if (stroke > 0) {
                e.style.border = "solid";
                e.style.borderWidth = (stroke * res) + "px";
                e.style.borderColor = stroke_color ?? color;
            } else {
                e.style.border = "none";
            }
            e.style.borderRadius = (radius * res) + "px";

            if (text_color) e.style.color = text_color;
            if (text_size) e.style.fontSize = (text_size * res) + "px";
            if (text_size) e.style.fontFamily = text_font;

            //interaction
            if (passive) {
                e.style.pointerEvents = "none";
            } else {
                if (on_down) {
                    e.addEventListener("pointerdown", (event: PointerEvent) => {
                        on_down(event);
                    }, { passive: false });
                }
                if (on_change) e.addEventListener("change", (event: Event) => { on_change(event); });
            }

            //anhängen
            parent.appendChild(e);
            this.list.push(e);
            return e;
        }
    };
    return self;
}